/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Lib_State_CancelledInputs */



/**
* | output |
* | --- |
* | "Cancelled" |
*
* @param {Tournaments_Lib_State_CancelledInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const tournaments_lib_state_cancelled = /** @type {((inputs?: Tournaments_Lib_State_CancelledInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Lib_State_CancelledInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Abgesagt")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Annulé")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("已取消")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("已取消")
	if (locale === "ko") return /** @type {LocalizedString} */ ("취소됨")
	return /** @type {LocalizedString} */ ("Cancelled")
});